module.exports = __webpack_public_path__ + "assets/img/003.df69433c.png";